import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { apiFetch } from './client';

export interface Document {
  id: string;
  slug: 'privacy_policy' | 'cookie_policy' | 'note_legali';
  content: string;
  updatedAt: string;
}

export function useDocument(slug: string) {
  return useQuery({
    queryKey: ['documents', slug],
    queryFn: () => apiFetch<Document>(`/documents/${slug}`),
  });
}

export function useSaveDocument() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ slug, content }: { slug: string; content: string }) =>
      apiFetch<Document>(`/admin/documents/${slug}`, {
        method: 'PUT',
        body: JSON.stringify({ content }),
      }),
    onSuccess: (data) => {
      qc.setQueryData(['documents', data.slug], data);
      qc.invalidateQueries({ queryKey: ['documents'] });
    },
    onError: (e: Error) => toast.error(e.message),
  });
}
